export default __webpack_public_path__ + "static/media/ponziani-taylor.3b4bb908.webp";